export const getInsuranceFileTypeLabel = (fileName: string) => {
  return fileName.split('.').pop()?.toUpperCase() || 'FILE';
};
